<template>
  <transition name="fade">
    <section class="mediaUploader">
      <a class="mediaUploader__overlay" @click="$emit('closeMediaUploader')">Close</a>
      <div class="mediaUploader__inner">
        <header class="mediaUploader__header">
          <nav class="mediaUploader__nav">
            <ul>
              <li><a @click="switchTab('add')" :class="{'is-active': curTab === 'add' }">Add media</a></li>
              <li><a @click="switchTab('library')" :class="{'is-active': curTab === 'library' }">Media library</a></li>
            </ul>
          </nav>
          <a class="mediaUploader__close" @click="$emit('closeMediaUploader')">
            <font-awesome-icon :icon="['fal', 'times']" />
          </a>
        </header>

        <div class="mediaUploader__content">
          <div class="mediaUploader__tab" v-if="curTab === 'add'">
            <vue-dropzone ref="vueDropzone" id="dropzone" @vdropzone-success="uploadSuccess" :options="dropzoneOptions" />
          </div>

          <div class="mediaUploader__tab" v-if="curTab === 'library'">
            <Loader v-if="isLoading" />
            <template v-else>
              <p v-if="mediaItems.data.length === 0" class="mediaUploader__message"><font-awesome-icon :icon="['fal', 'images']"/> Your media library is empty.</p>
              <div class="mediaUploader__listColumns" v-else>
                <div class="mediaUploader__listWrapper">
                  <ul class="mediaUploader__list">
                    <li class="mediaItem" @click="clickMedia(media)" :class="{ 'is-selected': selected === media, 'is-file': media.file }" v-for="media in mediaItems.data" :key="media.id">
                      <img :src="media.images.slider_thumb" :alt="media.alt" v-if="media.images">
                      <div v-else>
                        {{ media.file_name }}
                      </div>
                    </li>
                  </ul>
                  <div @click="resetSelected">
                    <Pagination
                      :pageSize=40
                      :pagination="mediaItems.pagination"
                      :Resource="mediaResouce"
                      :type="types.GET_ALL_MEDIA_ITEMS"
                      :isLoading="types.IS_LOADING_MEDIA_ITEMS"
                      :customParams="{order_by: 'id', sort_by: 'desc'}"
                    />
                  </div>
                </div>
                <aside class="mediaUploader__listSidebar">
                  <div class="form__group" v-if="selected.id">
                    <img :src="selected.images.slider_thumb" :alt="selected.alt" v-if="selected.images">

                    <label class="form__label" for="status">Original url:</label>
                    <input disabled type="text" class="form__input" v-model="selected.images.original" v-if="selected.images">
                    <input disabled type="text" class="form__input" v-model="selected.file" v-else>

                    <template v-if="selected.images">
                      <label class="form__label" for="status">Caption:</label>
                      <input type="text" class="form__input" v-model="selected.caption">

                      <label class="form__label" for="status">Alt text:</label>
                      <input type="text" class="form__input" v-model="selected.alt" v-if="selected.images">
                    </template>

                    <p>
                      <button type="button" class="btn btn--success" @click="updateMedia" v-if="selected.images">Update info</button>
                      <button type="button" class="btn btn--primary" @click="selectMedia" v-if="canSelect">Select</button>
                    </p>

                    <p><button type="button"  class="link link--danger" @click="deleteMedia"><font-awesome-icon :icon="['fal', 'trash-alt']" /> Delete permanently</button></p>
                  </div>
                </aside>
              </div>
            </template>
          </div>
        </div>
      </div>
    </section>
  </transition>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import * as types from '@/store/types.js'
import Media from '@/model/Media'
import Loader from '@/components/Utils/Loader'
import {search, deleteResource, getDate} from '@/helpers/resource'
import Pagination from '@/components/Utils/Pagination'

export default {
  components: {
    vueDropzone: vue2Dropzone,
    Loader,
    Pagination
  },
  computed: {
    mediaItems () {
      return this.$store.getters[types.ALL_MEDIA_ITEMS]
    },
    isLoading () {
      return this.$store.getters[types.IS_LOADING_MEDIA_ITEMS]
    },
    types () {
      return types
    },
    mediaResouce () {
      return Media
    },
    canSelect () {
      if (this.selected.images || this.canSelectFiles) {
        return true
      }

      return false
    }
  },
  props: {
    media: {
      default: null
    },
    canSelectFiles: {
      default: false
    }
  },
  data () {
    return {
      curTab: 'add',
      searchText: '',
      selected: {
        images: {
          medium: null
        },
        caption: null,
        alt: null,
        file: {}
      },
      status: '',
      search: {
        search: '',
        page: 1,
        page_size: 40,
        order_by: 'id',
        sort_by: 'desc'
      },
      dropzoneOptions: {
        addRemoveLinks: true,
        url: `${process.env.API_URL}media`,
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        maxFilesize: 50,
        headers: {
          'authorization': localStorage.getItem('token')
        },
        dictDefaultMessage: '<svg aria-hidden="true" data-prefix="fal" data-icon="cloud-upload" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" class="svg-inline--fa fa-cloud-upload fa-w-20"><path fill="currentColor" d="M272 64c60.28 0 111.899 37.044 133.36 89.604C419.97 137.862 440.829 128 464 128c44.183 0 80 35.817 80 80 0 18.55-6.331 35.612-16.927 49.181C572.931 264.413 608 304.109 608 352c0 53.019-42.981 96-96 96H144c-61.856 0-112-50.144-112-112 0-56.77 42.24-103.669 97.004-110.998A145.47 145.47 0 0 1 128 208c0-79.529 64.471-144 144-144m0-32c-94.444 0-171.749 74.49-175.83 168.157C39.171 220.236 0 274.272 0 336c0 79.583 64.404 144 144 144h368c70.74 0 128-57.249 128-128 0-46.976-25.815-90.781-68.262-113.208C574.558 228.898 576 218.571 576 208c0-61.898-50.092-112-112-112-16.734 0-32.898 3.631-47.981 10.785C384.386 61.786 331.688 32 272 32zm48 340V221.255l68.201 68.2c4.686 4.686 12.284 4.686 16.97 0l5.657-5.657c4.687-4.686 4.687-12.284 0-16.971l-98.343-98.343c-4.686-4.686-12.284-4.686-16.971 0l-98.343 98.343c-4.686 4.686-4.686 12.285 0 16.971l5.657 5.657c4.686 4.686 12.284 4.686 16.97 0l68.201-68.2V372c0 6.627 5.373 12 12 12h8c6.628 0 12.001-5.373 12.001-12z" class=""></path></svg><br /> Start your upload.'
      }
    }
  },
  methods: {
    switchTab (tab) {
      this.curTab = tab
      this.searchFilter()
    },
    uploadSuccess () {
      this.switchTab('library')
    },
    formatDate (date) {
      return getDate(date)
    },
    searchFilter () {
      search(Media, types.GET_ALL_MEDIA_ITEMS, types.IS_LOADING_MEDIA_ITEMS, this.search)
    },
    clickMedia (media) {
      this.selected = media
    },
    selectMedia () {
      this.$emit('update:media', this.selected)
      this.$emit('closeMediaUploader')
    },
    deleteMedia () {
      deleteResource(types.REMOVE_MEDIA, this.selected)
    },
    updateMedia () {
      Media.update(this.selected)
    },
    resetSelected () {
      this.selected = {
        images: {
          medium: null
        },
        caption: null,
        alt: null
      }
    }
  },
  mounted () {
    this.searchFilter()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Utils/MediaUploader.vue